import { render, staticRenderFns } from "./_Products.vue?vue&type=template&id=6ad4a955&scoped=true&"
import script from "./_Products.vue?vue&type=script&lang=js&"
export * from "./_Products.vue?vue&type=script&lang=js&"
import style0 from "./_Products.vue?vue&type=style&index=0&id=6ad4a955&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ad4a955",
  null
  
)

export default component.exports